module.exports = {
  'ar-ae': require('./ar-ae.json'),
  'ar-bh': require('./ar-bh.json'),
  'ar-kw': require('./ar-kw.json'),
  'ar-lb': require('./ar-lb.json'),
  'ar-om': require('./ar-om.json'),
  'ar-sa': require('./ar-sa.json'),
  'ar-qa': require('./ar-qa.json'),
  'bg-bg': require('./bg-bg.json'),
  'cs-cz': require('./cs-cz.json'),
  'da-dk': require('./da-dk.json'),
  'de-at': require('./de-at.json'),
  'de-ch': require('./de-ch.json'),
  'de-de': require('./de-de.json'),
  'de-lu': require('./de-lu.json'),
  'el-gr': require('./el-gr.json'),
  'en-ae': require('./en-ae.json'),
  'en-au': require('./en-au.json'),
  'en-bg': require('./en-bg.json'),
  'en-bh': require('./en-bh.json'),
  'en-cy': require('./en-cy.json'),
  'en-cz': require('./en-cz.json'),
  'en-dk': require('./en-dk.json'),
  'en-fi': require('./en-fi.json'),
  'en-gb': require('./en-gb.json'),
  'en-gr': require('./en-gr.json'),
  'en-hr': require('./en-hr.json'),
  'en-hu': require('./en-hu.json'),
  'en-ie': require('./en-ie.json'),
  'en-il': require('./en-il.json'),
  'en-is': require('./en-is.json'),
  'en-in': require('./en-in.json'),
  'en-kw': require('./en-kw.json'),
  'en-lb': require('./en-lb.json'),
  'en-mt': require('./en-mt.json'),
  'en-no': require('./en-no.json'),
  'en-nz': require('./en-nz.json'),
  'en-om': require('./en-om.json'),
  'en-pl': require('./en-pl.json'),
  'en-qa': require('./en-qa.json'),
  'en-ro': require('./en-ro.json'),
  'en-sa': require('./en-sa.json'),
  'en-se': require('./en-se.json'),
  'en-si': require('./en-si.json'),
  'en-sk': require('./en-sk.json'),
  'en-tr': require('./en-tr.json'),
  'en-za': require('./en-za.json'),
  'es-es': require('./es-es.json'),
  'fi-fi': require('./fi-fi.json'),
  'fr-be': require('./fr-be.json'),
  'fr-ch': require('./fr-ch.json'),
  'fr-fr': require('./fr-fr.json'),
  'fr-lu': require('./fr-lu.json'),
  'he-il': require('./he-il.json'),
  'hr-hr': require('./hr-hr.json'),
  'hu-hu': require('./hu-hu.json'),
  'it-ch': require('./it-ch.json'),
  'it-it': require('./it-it.json'),
  'iw-il': require('./iw-il.json'),
  'nl-be': require('./nl-be.json'),
  'nl-nl': require('./nl-nl.json'),
  'no-no': require('./no-no.json'),
  'pl-pl': require('./pl-pl.json'),
  'pt-pt': require('./pt-pt.json'),
  'ro-ro': require('./ro-ro.json'),
  'ru-ru': require('./ru-ru.json'),
  'ru-ua': require('./ru-ua.json'),
  'sk-sk': require('./sk-sk.json'),
  'sl-si': require('./sl-si.json'),
  'sr-rs': require('./sr-rs.json'),
  'sv-se': require('./sv-se.json'),
  'tr-tr': require('./tr-tr.json'),
  'uk-ua': require('./uk-ua.json'),
};
